import { useTranslation } from 'next-i18next/pages'
import React from 'react'
import { Drawer } from './Drawer'
import { SaveList } from './SaveList'

interface LoadDrawerProps {
  isOpen: boolean
  onClose: () => void
}

export function LoadDrawer({ isOpen, onClose }: LoadDrawerProps) {
  const { t } = useTranslation(['modals', 'common'])

  return (
    <div>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        title={t('SaveList.SavedLists')}
        maxWidth="max-w-96"
        closeLabel={t('common:Accessibility.closePanel')}
      >
        <SaveList handleClose={onClose} />
      </Drawer>
    </div>
  )
}
